module.exports = __webpack_public_path__ + "img/apple_pay.1f7bbf3d.svg";